import { fetchMenu } from "../data/query.js";
import { useMenuAxios } from "../context/axios.js";
import { useQuery } from "@tanstack/react-query";
//#region src/modules/core/hooks/use-menu-query.ts
var useMenuQuery = () => {
	const { instance } = useMenuAxios();
	return useQuery({
		queryKey: ["menu"],
		queryFn: () => fetchMenu(instance)
	});
};
//#endregion
export { useMenuQuery };
